import React from 'react';
import { useRouter } from 'next/router';
import NextLink from 'next/link';
import qs from 'query-string';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import useBreakpointIsMobile from 'hooks/useBreakpointIsMobile';

import { Base } from 'styled';

type Props = {
  pageNumber: number;
  totalPages: number;
};

function BrowsePagePagination(props: Props) {
  const isMobile = useBreakpointIsMobile();
  const { query, pathname, asPath } = useRouter();

  return (
    <Base display="flex" justifyContent="center">
      <Pagination
        className="min-w-max"
        color="primary"
        count={props.totalPages}
        page={props.pageNumber}
        size={isMobile ? 'small' : 'large'}
        renderItem={(item) => (
          <PaginationItem
            key={item.page}
            component={(componentProps) => (
              <NextLink
                href={`${pathname}${item.page !== 1 || asPath.includes('?') ? '?' : ''}${qs.stringify({ ...query, page: item.page === 1 ? undefined : item.page })}`}
                passHref
                prefetch={false}
                rel="canonical"
                {...componentProps}
              ></NextLink>
            )}
            {...item}
          />
        )}
      />
    </Base>
  );
}

export default BrowsePagePagination;
